// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__19kCy","validationTips":"StatementDescriptor_validationTips__2dVC-"};